module.exports = __webpack_public_path__ + "static/media/shapes-bg.4366a701.png";